
<template>
  <v-card
    class="card_tile"
    v-if="
      displayTile &&
      peopleTileSearchObj &&
        ypoSearchText
    "
  >
    <v-flex class="card_tile__border">
      <span class="ypo-search-title">{{ peopleTileConstants.TITLE }}</span>
      <v-flex>
        <status-overlay
          content-height="200px"
          :action="loadingAction"
        ></status-overlay>
        <v-layout v-if="hasSuggestionResults" column pt-2>
          <v-flex
            class="result_block__row"
            v-for="(member, index) in peopleTileSearchObj.profileDetails"
            :key="index.id"
          >
            <v-avatar @click="openMemberProfile(member)" size="60">
              <img
                :src="profileImage(member.profileImage) + timestamp"
                :key="member.profileImage"
                :alt="memberName(member)"
                :onerror="imageErrorFallback(member.fallbackProfileImageUrl)"
              />
            </v-avatar>
            <v-flex xs12 class="result_block__info">
              <p
                class="result_block__info__memberName"
                @click="openMemberProfile(member)"
              >
                {{ memberName(member) }}
              </p>
              <p class="result_block__info__chapterName">
                {{ memberChapter(member) }}
              </p>
              <p class="result_block__info__memberLocation">
                {{ memberPlace(member) }}
              </p>
              <small
                v-if="
                  member.roleForSearch ===
                    peopleTileConstants.MANAGEMENT_ASSOCIATE
                "
              >
                {{ member.position }}
              </small>
              <small
                v-if="
                  userChampionPosition(member) &&
                    member.roleForSearch !==
                      peopleTileConstants.MANAGEMENT_ASSOCIATE
                "
              >
                {{ userChampionPosition(member) }}
              </small>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-layout v-if="searchCompleted" class="people-search-nav">
          <v-flex class="people-search-nav__buttons">
            <v-layout column>
              <v-flex
                v-if="!hasSuggestionResults"
                class="card_tile__no-result"
              >
                {{ peopleTileConstants.NO_RESULTS }}
              </v-flex>
              <v-flex
                  v-if="hasSuggestionResults && !peopleTileSearchObj.isNameFound"
                  class="card_tile__v-btn-container"
              >
                <v-btn
                    class="card_tile__v-btn-all-matches card_tile__v-btn-all-matches--non-member-result-found"
                    @click="openAdvancedSearchPageAllMatches"
                >
                  {{ peopleTileConstants.ALL_MATCHES }}
                </v-btn>
              </v-flex>
              <v-flex
                v-if="hasSuggestionResults && peopleTileSearchObj.isNameFound"
                class="card_tile__v-btn-container"
              >
                <v-btn
                  class="card_tile__v-btn-all-matches"
                  @click="openAdvancedSearchPageAllMatches"
                >
                  {{ peopleTileConstants.ALL_MATCHES }}
                </v-btn>
                <v-btn
                  class="card_tile__v-btn-find-matches-by-name"
                  @click="openAdvancedSearchPageByName"
                >
                  {{ peopleTileConstants.FIND_MATCHES_BY_NAME }}
                </v-btn>
              </v-flex>
              <v-flex>
                <p v-if="hasSuggestionResults"
                class="result_block__info__memberDirectory"
                @click="openPeopleSearchPage"
              >
                {{ peopleTileConstants.FULL_MEMBER_DIRECTORY }}
              </p>
              <v-btn v-if="!hasSuggestionResults"
               class="card_tile__all-matching"
               @click="openPeopleSearchPage"
              >
                {{peopleTileConstants.FULL_MEMBER_DIRECTORY_NO_RESULTS}}
              </v-btn>
              </v-flex>
              
            </v-layout>
          </v-flex>
          
          <v-flex
            v-if="!hasSuggestionResults"
            class="people-search-nav__no-result-img"
          >
            <v-img
              :src="require('../../assets/YpoSearch/search.png')"
              class="card_tile__search-image"
            ></v-img>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { storeAction } from "@/store/storeActions.constant";
import { storeGetters } from "@/store/storeGetters.constant";
import { storeMutation } from "@/store/storeMutations.constant";
import { routerNames } from "../appCommon.constants";
import { imageErrorFallback } from "@/common/utils/utils";
import StatusOverlay from "../StatusOverlay/StatusOverlay";
import NoResultsAvailable from "./NoResultsAvailable";
import { memberDirectorySearchObject } from "@/store/store.constant";
import {
  globalSearchConstants,
  peopleTileConstants,
  constructSortFilters,
  facetLabel,
} from "./ypoSearch.constants";
import { appConstant } from "@/app.constant";
import { gaDataLayerEvent } from "@/plugins/analytics";
import { gtmEventName } from "@/plugins/gtmAnalytics";
import { commonEnvVariables } from "@/commonEnvVariables";

export default {
  name: "PeopleTile",
  data: () => ({
    peopleTileConstants,
    globalSearchConstants,
    displayTile: true,
    routerNames,
    memberDirectorySearchObject,
    timestamp: `?t${new Date().getTime()}`,
  }),
  props: {
    peopleTileSearchObj: {
      required: true,
      type: Object,
    },
    ypoSearchText: {
      type: String,
      required: true,
    },
    postSelectCallback: {
      type: Function,
      required: true,
    },
    searchCompleted: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    StatusOverlay,
    NoResultsAvailable,
  },
  methods: {
    ...mapActions({
      handleLaunchOfMemberProfile: `memberProfile/${storeAction.handleLaunchOfMemberProfile}`,
      getPeopleOneClickSearchSuggestions: `ypoSearch/${storeAction.getPeopleOneClickSearchSuggestions}`,
      getYPOSpeakers: `searchSpeaker/${storeAction.getYPOSpeakers}`,
      initiateTracking: `ypoSearch/${storeAction.initiateTracking}`,
    }),
    ...mapMutations({
      setMemberDirectorySearchText: `memberDirectory/${storeMutation.setMemberDirectorySearchText}`,
      setMemberDirectorySort: `memberDirectory/${storeMutation.setMemberDirectorySort}`,
      setMemberSelectedLetterFilter: `memberDirectory/${storeMutation.setMemberSelectedLetterFilter}`,
    }),
    profileImage(imageUrl) {
      return imageUrl;
    },
    constructSortFilters,
    facetLabel,
    memberName(member) {
      return `${member.memberName || ""} `;
    },
    memberPlace(member) {
      return `${member.liveLocation || ""}`;
    },
    memberChapter(member) {
      return member.chapterName;
    },
    facetOtherLabel(facet, expectedLabel) {
      return facet.integratedSearchName === expectedLabel ? expectedLabel : "";
    },
    imageErrorFallback,
    openMemberProfile(member) {
      if (this.postSelectCallback) this.postSelectCallback();
      const trackingObject = {
        committedSearchTerm: this.ypoSearchText,
        tileText: this.hasSuggestionResults
          ? `${member.firstName} ${member.lastName}`
          : null,
        tileType: globalSearchConstants.PEOPLE,
      };
      this.handleLaunchOfMemberProfile({
        memberId: member.memberId,
        router: this.$router,
      });
      this.initiateTracking(trackingObject);
    },
    userChampionPosition(user) {
      return user &&
        user.currentChampionPositions &&
        user.currentChampionPositions.length
        ? user.currentChampionPositions[0].name
        : null;
    },
    openPeopleSearchPage() {
      window.open(commonEnvVariables().FULL_MEMBER_DIRECTORY, '_self');
      return false;
    },
    openAdvancedSearchPageAllMatches() {
      const redirectUrl = `${process.env.VUE_APP_SALESFORCE_URL_ROOT}${peopleTileConstants.MEMBERDIRECTORY_SEARCH_PAGE}${this.ypoSearchText}&searchType=Advanced`;
      window.open(redirectUrl, "_self");
    },
    openAdvancedSearchPageByName() {
      const redirectUrl = `${process.env.VUE_APP_SALESFORCE_URL_ROOT}${peopleTileConstants.MEMBERDIRECTORY_SEARCH_PAGE}${this.ypoSearchText}&searchType=Name`;
      window.open(redirectUrl, "_self");
    },
    createAFilterPill(facet) {
      if (this.postSelectCallback) this.postSelectCallback();
      this.setMemberSelectedLetterFilter();
      sessionStorage.removeItem(appConstant.storageKeys.memberDirectoryStoredFilters);
      const {
        key,
        name,
        fieldToQuery,
        integratedSearchName,
      } = facet;
      const trackingObject = {
        committedSearchTerm: this.ypoSearchText,
        oneClickSearchText: this.showFacets ? facet.name : null,
        oneClickSearchType: globalSearchConstants.PEOPLE,
      };
      if (
        name === globalSearchConstants.YPO_MANAGEMENT_ASSOCIATES ||
        name === globalSearchConstants.CHAPTER_ADMINISTRATORS
      ) {
        const pillFilter = {
          ...facet.filters[0],
          key,
          name,
          fieldToQuery,
          integratedSearchName,
        };
        this.launchMemberDirectoryPage(pillFilter);
      } else if (name === globalSearchConstants.MY_NETWORKS) {
        const pillFilter = {
          ...facet.filters[0],
          label: name,
        };
        this.launchMemberDirectoryPage(pillFilter);
      } else if (name === globalSearchConstants.MY_PRIMARY_CHAPTER) {
        const pillFilter = {
          ...facet.filters[0],
        };
        this.launchMemberDirectoryPage(pillFilter);
      } else if (name === globalSearchConstants.CFF) {
        this.$router.push({
          path: `/speakerPage/${routerNames.SEARCH_SPEAKERS}`,
          query: {
            speakersWhoAre: key,
            speakerSearchText: this.ypoSearchText,
          },
        });
      } else {
        const sortFilters = this.constructSortFilters(facet.filters[0].label);
        const { label } = facet.filters[0];
        this.setMemberDirectorySort(sortFilters);
        const pillFilter = {
          ...facet.filters[0],
          key,
          name,
          fieldToQuery,
          integratedSearchName,
          label:
            label === globalSearchConstants.CHAMPION_POSITIONS
              ? globalSearchConstants.CHAPTER_OFFICERS
              : this.facetLabel(
                  label,
                  integratedSearchName,
                  this.ypoSearchText
                ),
          filterValue: this.ypoSearchText,
        };
        if (label.toLowerCase() !== routerNames.SPEAKER) {
          this.launchMemberDirectoryPage(pillFilter);
        } else if (label.toLowerCase() === routerNames.SPEAKER) {
          this.$router.push({
            path: `/speakerPage/${routerNames.SEARCH_SPEAKERS}`,
            query: {
              speakerSearchText: this.ypoSearchText,
            },
          });
        }
      }
      gaDataLayerEvent(gtmEventName.C_People_Search_Trigger, facet.name);
      this.initiateTracking(trackingObject);
    },
    launchMemberDirectoryPage(pillFilter) {
      if (this.$route.name === routerNames.MEMBER_DIRECTORY_PAGE) {
        this.$router.push({
          query: {
            ...this.$route.query,
            filters: JSON.stringify({
              searchFilters: [pillFilter],
            }),
            searchText: this.ypoSearchText ? this.ypoSearchText : "",
          },
        });
      } else {
        this.$router.push({
          path: `/${routerNames.MEMBER_DIRECTORY_PAGE}`,
          query: {
            filters: JSON.stringify({
              searchFilters: [pillFilter],
            }),
            searchText: this.ypoSearchText ? this.ypoSearchText : "",
          },
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      currentUserId: `memberProfile/${storeGetters.currentUserId}`,
      isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
    }),
    ...mapState("actionState", ["actions"]),
    loadingAction() {
      return this.actions[storeAction.getPeopleSearchSuggestions];
    },
    hasSuggestionResults() {
      return (
        this.peopleTileSearchObj &&
        this.peopleTileSearchObj.profileDetails &&
        this.peopleTileSearchObj.profileDetails.length > 0
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";

.card_tile {
  text-align: left !important;
  padding: 20px 0 20px 20px;
  box-shadow: none;
  height: 100vh;

  @include breakpoint(md) {
    height: unset !important;
  }

  &__border {
    height: 100vh;
    border-right: 1px solid $ypo-tile-border;
    @include breakpoint(xs) {
      border-right: none;
    }
    @include breakpoint(sm) {
      height: unset !important;
    }
  }

  &__v-btn-all-matches {
    background-color: $white !important;
    color: $ypo-blue;
    border: 1.5px solid $ypo-blue;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    height: 30px;
    margin: 10px 10px 2px 2px;

    &--non-member-result-found {
      background-color: $ypo-blue !important;
      color: $white;
      padding: 3px 25px;
    }
  }

  &__v-btn-find-matches-by-name {
    background-color: $ypo-blue !important;
    color: $white;
    border-radius: 6px;
    height: 30px;
    font-size: 12px;
    font-weight: 600;
    margin: 10px 0 0 2px;
  }

  &__no-result {
    display: flex;
    font-family: Raleway, serif;
    font-style: italic;
    margin-top: 10px;
  }

  &__search-image {
    max-width: 130px;
    max-height: 100px;
    display: flex;
  }

  &__all-matching {
    display: flex;
    margin-top: 15px;
    background-color: $ypo-blue !important;
    color: $white;
    border-radius: 6px;
    font-size: 12px;
    width: 200px;
    height: 30px;
    left: -6px;
    font-weight: 600;
  }
}

.search-flex {
  display: flex;
  @include breakpointMin(xs) {
    display: block;
  }
  @include breakpointMin(xl) {
    display: flex;
  }
}

.advanced-search {
  margin-top: -2px;
  @include breakpointMin(xs) {
    margin-top: 10px;
    margin-left: 0;
  }
  @include breakpointMin(xl) {
    margin-top: 0;
    margin-left: 10px;
  }
}

.label-gold {
  font-size: 10px;
  cursor: default;
  background: $ypo_gold;
  color: $white;
  font-weight: 500;
  padding: 3px 5px;
  text-transform: uppercase;
  border-radius: 6px;
}

.divider {
  color: $black;
  font-weight: 500;
}

.one-click-search-results {
  flex-direction: column;
  @include breakpoint(sm) {
    flex-direction: row;
    flex-wrap: wrap;
  }

  &__item {
    @include breakpoint(sm) {
      border: 1px solid $ypo-cta;
      box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.2);
      margin: 6px 3px;
      padding: 6px;
      max-width: fit-content !important;
      height: 36px;
    }
    padding: 6px 15px 6px 0;
    font-family: "Raleway", sans-serif;

    &--other-label {
      color: $black;
      font-size: 12px;
      font-family: "Noto Sans", sans-serif;
    }

    &--label {
      font-size: 14px;
      color: $ypo-cta;
      text-decoration: none;
    }
  }
}

.result_block {
  position: relative;
  border-bottom: 1px solid $ypo-tile-border;
  margin-right: 30px;
  margin-bottom: 10px;

  &__row {
    position: relative;
    padding-left: 70px;
    margin-bottom: 10px;
    min-height: 70px;
    align-items: center;
    display: inherit;
    transition: 0.3ms all ease;

    &:hover {
      background: $ypo-extra-light-gray;
    }

    .v-avatar {
      position: absolute;
      left: 0;
      top: 5px;
      border: 3px solid $ypo-tile-border;
      border-radius: 150px;
      overflow: hidden;
    }
  }

  &__info {
    &__chapterName {
      font-weight: bold !important;
      color: $ypo-dark-gray !important;
      font-size: 12px !important;
      margin: 0;
      line-height: 16px;
      font-family: "Noto Sans", sans-serif;
    }
    &__memberLocation {
      font-weight: normal;
      color: $ypo-dark-gray !important;
      font-size: 12px !important;
      margin: 0;
      line-height: 16px;
      font-family: "Noto Sans", sans-serif;
    }
    &__memberName {
      display: block;
      color: $ypo-cta !important;
      font-family: "Raleway", sans-serif;
      font-size: 14px !important;
      font-weight: bold !important;
      line-height: 20px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      cursor: pointer;
      margin: 0 !important;
    }
    &__memberDirectory {
      display: block;
      color: $ypo-cta;
      font-family: "Raleway", sans-serif;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      cursor: pointer;
      margin-top: 15px;
      margin-left: 3px;
    }
    small {
      display: block;
      color: $black;
      font-size: 12px;
      letter-spacing: -0.1px;
      line-height: 16px;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      cursor: pointer;
      font-family: "Noto Sans", sans-serif;
    }
  }
}

.people-search-nav {

  &__buttons {
    flex-basis: 70%;
  }
  &__no-result-img {
    flex-basis: 30%;
  }
}
</style>
